const createTab = ({
    uid,
    type,
    label,
    docs,
}: {
    uid: string;
    type: string;
    label: string;
    docs?: { title?: string; url?: string };
}) => ({
    tab: { uid, label, docs },
    content: { uid, type },
});

export const logsTabKey = "logs";
export const logsContentType = "logsListing";
export const logsTab = createTab({ uid: logsTabKey, label: "Logs", type: logsContentType });

export const usedByContentKey = "usedByList";
export const usedByTab = createTab({ uid: "usedBy", type: usedByContentKey, label: "Used by" });

export const holdingTheLockTabKey = "holdingTheLock";
export const holdingTheLockTab = createTab({
    uid: holdingTheLockTabKey,
    label: "Holding the lock",
    type: usedByContentKey,
});

export const waitingForLockTab = createTab({
    uid: "waitingForLock",
    label: "Waiting for lock",
    type: usedByContentKey,
});

export const usedByWebhooksList = "usedByWebhooksList";
export const usedByWebhooksTab = createTab({
    uid: usedByWebhooksList,
    label: "Webhooks",
    type: usedByContentKey,
});
export const usedBySchedulesList = "usedBySchedulesList";
export const usedBySchedulesTab = createTab({
    uid: usedBySchedulesList,
    label: "Schedules",
    type: usedByContentKey,
});

export const inputSchemaTabKey = "inputSchemaTab";
export const inputSchemaContentType = "inputSchema";
export const inputSchemaTab = createTab({
    uid: inputSchemaTabKey,
    label: "Input schema",
    type: inputSchemaContentType,
    docs: {
        title: "Schema creation and validation",
        url: "/docs/schema-creation-and-validation#input-and-output-schema",
    },
});
export const outputSchemaTabKey = "outputSchemaTab";
export const outputSchemaContentType = "outputSchema";
export const outputSchemaTab = createTab({
    uid: outputSchemaTabKey,
    label: "Output schema",
    type: outputSchemaContentType,
    docs: {
        title: "Schema creation and validation",
        url: "/docs/schema-creation-and-validation#input-and-output-schema",
    },
});

export const wrappersTabKey = "resourceWrappersTab";
export const wrappersContentType = "resourceWrappers";
export const wrappersTab = createTab({
    uid: wrappersTabKey,
    label: "Wrappers",
    type: wrappersContentType,
});

export const valueAndSchemaTabKey = "valueAndSchemaTabKey";
export const valueAndSchemaContentType = "valueAndSchema";
export const valueAndSchemaTab = createTab({
    uid: valueAndSchemaTabKey,
    label: "Configuration",
    type: valueAndSchemaContentType,
});

export const metadataTabKey = "metadataTab";
export const metadataContentType = "metadata";
export const metadataTab = createTab({
    uid: metadataTabKey,
    type: metadataContentType,
    label: "Metadata",
});

export const commentsTabKey = "commentsTab";
export const commentsContentType = "comments";
export const commentsTab = createTab({
    uid: commentsTabKey,
    type: commentsContentType,
    label: "Comments",
});

export const valueAndSchemaInput = "valueAndSchemaInput";
export const valueAndSchemaOutput = "valueAndSchemaOutput";
export const valueAndSchema = "valueAndSchema";

export const schedulerKey = "allSchedulers";

export const executionRelatedRecordsTabKey = "executionRelatedRecordsTab";
export const executionRelatedRecordsContentType = "executionRelatedRecords";
export const executionRelatedRecordsTab = createTab({
    uid: executionRelatedRecordsTabKey,
    label: "Related records",
    type: executionRelatedRecordsContentType,
});
